import { cloneDeep, forEach } from 'lodash-es';
import Moment from 'moment/moment';
import qs from 'qs';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import DefaultModal from '../../components/modal';
import OrderStatusShow from '../../components/orderStatusShow';
import Pager from '../../components/pager';
import TmsDatepicker from '../../components/tmsDatepicker';
import UnisDefaultOptionOutline from '../../components/unisDefaultOptionOutline';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import UnisProductModal from '../../components/unisProductModal';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import tmsServiceBlob from '../../services/axios/tmsServiceBlob';
import { analytics } from '../../services/analytics';
import DrayageOrder from '../../services/drayage/order';
import switchBillingToService from '../../shared/switchBillingToService';
import util from '../../shared/util';
import trackingGuest from '../trackingGuest';
import Actions from './components/actions';
import Pagination from './components/pagination';
import template from './shipment.vue';

@Component({
    mixins: [template],
    components: {
        DefaultModal,
        Actions,
        Pagination,
        Pager,
        UinsDefaultSelect,
        UnisProductModal,
        TmsDatepicker,
        UnisDefaultOptionOutline,
        OrderStatusShow,
        trackingGuest,
    },
})
export default class Shipment extends Vue {
    /* 页面直接字段 开始 */
    rows: any = [];
    rowsReturned: boolean = false;
    userSource: boolean = false;
    currentPageIndex = 0;
    rowsPerPage = 7;
    editProductModal: string = 'payForSelectedInvoices';
    currentPageRows: Array<any> = [];
    searchText: any = '';
    status_type: string = '';
    timeArr: any = [];
    allshipments: string = '';
    showFields: Object = {
        pu: true,
        pro: true,
        order: true,
        container: true,
        service: true,
        origin: true,
        pickupDate: true,
        destination: true,
        appointmentDate: true,
        appointmentTime: true,
        deliveryDate: true,
        orderStatus: true,
    };
    isCustomizeFieldsActive: boolean = false;
    paging: any = {
        pageSize: 10,
        currentPage: 1,
        totalSize: 0,
    };

    isShowWalkthrough: Boolean = false;
    cloneFilterTables: any = '';
    resChoosingUNIS: any = 'resChoosingUNIS';
    filesmodalName: any = 'FilesmodalName';
    isBusinessType: Boolean = false;
    isys: Boolean = false;
    billto_id: any = '';
    PODfiles: any = '';
    showPODfiles: boolean = false;
    orderStatus: string = '';
    orderStatuses: Array<any> = [
        { label: 'All', value: '0' },
        { label: 'Pickup Created', value: '1' },
        { label: 'Pickup Dispatched', value: '2' },
        { label: 'Pickup Completed', value: '3' },
        { label: 'In Transit', value: '4' },
        { label: 'Pending Delivery', value: '5-1' },
        { label: 'Out for Delivery', value: '5' },
        { label: 'Delivered', value: '6' },
    ];

    tableFieldsObjs: Array<any> = [
        {
            label: 'PU #',
            value: 'fk_tms_order_group_id',
        },
        {
            label: 'PRO #',
            value: 'tms_order_pro',
        },
        // {
        //     label: 'order',
        //     value: 'tms_order.tms_order_id',
        // },
        {
            label: 'Service',
            value: 'tms_quote_from',
        },
        {
            label: 'Origin',
            value: 'wa1.location_code',
        },
        {
            label: 'Pickup Date',
            value: 'tms_order_pickup_date',
        },
        {
            label: 'Destination',
            value: 'wa2.location_code',
        },
        {
            label: 'Delivery Date',
            value: 'tms_order_appointment_delivery_date',
        },
    ];
    ProductModal: string = 'changePickDate';
    closeModal() {
        this.$modal.hide(this.ProductModal);
    }
    FilterTables: Array<any> = [];
    isGettingOrderList = false;
    trackingGuestOrderId: any = '';

    addFilterTables() {
        this.FilterTables.push({
            filter: '',
            or: '',
            value: '',
        });
    }

    get eyeIcon() {
        if (this.isCustomizeFieldsActive) {
            return require('@/assets/images/eye-active.svg');
        } else {
            return require('@/assets/images/eye.svg');
        }
    }

    async mounted() {
        this.init();
        util.showUserWalkthrough();
        util.showUserWalkNext('ShipmentListItem', this);
        let _this = this;
        (window as any).gotItfinished = _this.gotItfinished;
        await this.getCustomerData();
        if (this.$route.query && this.$route.query.searchText) {
            this.searchText = this.$route.query.searchText;
        }
        this.FilterTableSearch(1);
    }

    private async getCustomerData() {
        await switchBillingToService
            .post()
            .then((res: any) => {
                if (res.data.billing) {
                    if (
                        res.data.billing.location_payment_type &&
                        res.data.billing.location_payment_type == 'deposit'
                    )
                        this.userSource = true;
                }
                if (res.data.billing != undefined && res.data.billing.location_id) {
                    this.billto_id = res.data.billing.location_id;
                } else {
                    // this.UserWalkNext();
                }
            })
            .catch(error => {
                // console.log(error);
                // this.UserWalkNext();
            });
    }

    updated() {
        // console.log(this.showFields);
    }

    // end of life cycle methods

    toggleCustomizeFields() {
        this.isCustomizeFieldsActive = !this.isCustomizeFieldsActive;
    }

    setCurrentPageRows() {
        /* this.currentPageRows = this.rows.slice(
         this.currentPageIndex * this.rowsPerPage,
         (this.currentPageIndex + 1) * this.rowsPerPage
         );*/
    }

    updateCurrentPageIndex(index: number) {
        this.currentPageIndex = index;
        this.setCurrentPageRows();
    }

    getList(page: any) {
        this.paging.pageSize = page.pageSize;
        this.FilterTableSearch(page.currentPage);
    }

    searchShipmentsByinput() {
        this.FilterTables = [];
        if (!this.searchText) {
            let fullUrl: any = window.location.href;
            let hashPart: any = fullUrl.split('#')[1] || '';
            const searchText = hashPart.split('searchText=')[1];
            const newUrl = fullUrl.replace(searchText, '');
            window.history.replaceState(null, '', newUrl);
        }

        this.FilterTableSearch(1, true);
    }

    searchShipments() {
        this.FilterTables = [];
        this.FilterTableSearch(1);
    }

    isLoading = false;

    redirectCustomerSignup() {
        window.location.href = '#/customerSignup';
    }

    redirectQuote() {
        this.$router.replace({
            name: 'Quote',
        });
    }

    openBOL(order: number) {
        window.open('/tms_pdf_bol.php?order_id=' + order);
    }

    openShipping(order: number) {
        window.open('/tms_pdf_shipping_label.php?order_id=' + order);
    }

    openUrlInNewWindow(url: string) {
        window.open(url);
    }

    getQuoteModal: string = 'getQuoteModal';
    getQuoteModalRightBtnStyle: any = {
        'background-color': '#f7b020 !important',
        color: '#15223d !important',
    };

    getQuoteModalRightBtnAction() {
        window.location.href = '#/lastMileQuote';
    }

    getQuoteModalLeftBtnAction() {
        window.location.href = '#/unis100Quote';
    }

    setPriority(params: any) {
        DrayageOrder.setPriority(params).then(response => {
            // console.log(response);
            if (response.data.status === 1) {
                this.rows.find((item: any) => item.order_id === params.order_id).is_priority =
                    params.is_priority;
            }
        });
    }

    editQuote(id: any) {}

    contactHelp(id: any) {}

    showReset() {
        this.FilterTables = [
            {
                filter: '',
                or: '',
                value: '',
            },
        ];
        // this.$modal.hide(this.editProductModal);
    }
    closeReset() {
        this.$modal.hide(this.editProductModal);
    }

    Filters() {
        this.FilterTables = [
            {
                filter: '',
                or: '',
                value: '',
            },
        ];
        this.$modal.show(this.editProductModal);
    }

    applyFilters() {
        const filterCount = this.FilterTables.filter(item => item && item.filter).length;
        analytics.trackButtonClick({ buttonName: 'apply_shipment_filters' });
        analytics.trackFilterApply({ filterType: 'shipment', filterCount });
        this.FilterTableSearch(1);
    }

    removeFilter(index: any) {
        this.FilterTables.splice(index, 1);
    }

    FilterTableSearch(page: any, trackSearch: boolean = false) {
        if (!this.billto_id) {
            return;
        }
        this.$modal.hide(this.editProductModal);
        let params: any = {};
        if (this.FilterTables.length > 0) {
            params.filter_str = [];
        }
        params.billto_id = this.billto_id;
        params.page = page;
        if (this.searchText) params.search_text = this.searchText;
        if (this.status_type && this.status_type != '0') {
            if (this.status_type == '5-1') {
                params.status_type = '5';
                params.is_trip_order_created_from_lh = '1';
            } else {
                if (this.status_type == '5') {
                    params.is_trip_order_created_from_lh = '0';
                }
                params.status_type = this.status_type;
            }
        }
        params.page_size = this.paging.pageSize;
        this.cloneFilterTables = cloneDeep(this.FilterTables);
        if (this.FilterTables.length > 0) {
            forEach(this.FilterTables, Filter => {
                if (Filter.filter) {
                    let keyVaule = `${Filter.filter}`;
                    if (Filter.or == 'is') keyVaule = keyVaule + '=';
                    if (Filter.or == 'is not') keyVaule = keyVaule + '!=';
                    if (Filter.or == 'before') keyVaule = keyVaule + '<';
                    if (Filter.or == 'after') keyVaule = keyVaule + '>';
                    keyVaule = keyVaule + `'${Filter.value}'`;
                    params.filter_str.push(keyVaule);
                }
            });
        }
        this.FilterTables = [
            {
                filter: '',
                or: '',
                value: '',
            },
        ];
        this.isGettingOrderList = true;
        tmsServiceBackend.post('/cpv2/orders', qs.stringify(params)).then(
            (response: any) => {
                this.currentPageIndex = 0;
                this.currentPageRows = response.data.data.data;
                this.currentPageRows.forEach(item => {
                    item.delivery_date_time_range = '';
                    if (item.delivery_date_actual) {
                        item.delivery_date_time_range = Moment(item.delivery_date_actual).format(
                            'HH:mm'
                        );
                    } else {
                        if (item.delivery_date) {
                            const timeFrom = item.delivery_date_time;
                            const timeTo = item.delivery_date_time_to;
                            if (timeFrom === '0' && timeTo === '0') {
                                item.delivery_date_time_range = '';
                            } else {
                                const formattedTimeFrom = Moment(`06/20/2021 ${timeFrom}`).format(
                                    'HH:mm'
                                );
                                const formattedTimeTo = Moment(`06/20/2021 ${timeTo}`).format(
                                    'HH:mm'
                                );
                                if (timeFrom !== '0' && timeTo !== '0') {
                                    item.delivery_date_time_range =
                                        timeFrom === timeTo
                                            ? formattedTimeFrom
                                            : `${formattedTimeFrom} - ${formattedTimeTo}`;
                                } else {
                                    item.delivery_date_time_range =
                                        timeFrom !== '0' ? formattedTimeFrom : formattedTimeTo;
                                }
                                if (item.delivery_date_time_range === 'Invalid date') {
                                    item.delivery_date_time_range = '';
                                }
                            }
                        }
                    }
                });
                // this.currentPageRows = [];
                this.paging.totalSize = response.data.data.total;
                this.paging.currentPage = response.data.data.current_page;
                if (!this.currentPageRows) {
                    this.paging.totalSize = 0;
                    this.paging.currentPage = 0;
                }
                if (this.currentPageRows && this.currentPageRows.length == 0) {
                    this.paging.totalSize = 0;
                    this.paging.currentPage = 0;
                }
                if (trackSearch) {
                    analytics.trackSearch({
                        searchType: 'shipment_reference',
                        success: true,
                        resultCount: this.currentPageRows ? this.currentPageRows.length : 0,
                        hasSearchTerm: Boolean(this.searchText),
                    });
                }
                this.isGettingOrderList = false;
            },
            (err: any) => {
                if (trackSearch) {
                    analytics.trackSearch({
                        searchType: 'shipment_reference',
                        success: false,
                        resultCount: 0,
                        hasSearchTerm: Boolean(this.searchText),
                    });
                }
                this.err(err);
                this.isGettingOrderList = false;
            }
        );
    }

    shareTrackingDetails(details: any) {
        localStorage.setItem('ShipmentViewFrom', '2');
        if (details.order_id) {
            this.$router.push({
                name: 'ShipmentView',
                params: {
                    orderId: details.order_id,
                    from: '1',
                },
            });
        }
    }

    generateBOL(item: any) {
        this.$router.push({
            name: 'Billoflading',
            params: {
                orderId: item.order_id,
            },
        });
    }

    viewBOL(item: any) {
        this.$router.push({
            name: 'Bol',
            params: {
                id: item.order_id,
            },
        });
    }

    onClickrow(item: any) {
        this.trackingGuestOrderId = item.order_id;
        this.replaceUrl(this.searchText);
    }

    UserWalkNext() {
        this.isBusinessType = localStorage.getItem('guideDone') == 'true' ? true : false;
        let guideDoneStage = localStorage.getItem('guideDoneStage');
        let guideDoneStageNumber = Number(localStorage.getItem('guideDoneStageNumber'));
        if (!this.isBusinessType && (!guideDoneStageNumber || guideDoneStageNumber < 3)) {
            this.$modal.show(this.resChoosingUNIS);
            localStorage.removeItem('guideDoneStage');
            util.showUserWalkNext('', this);
        }
        // let stageNumber = localStorage.getItem("guideDoneStageNumber");
    }

    restartWalkthrough() {
        let stageNumber = localStorage.getItem('guideDoneStageNumber');
        if (stageNumber) {
            if (stageNumber && Number(stageNumber) == 2)
                tmsServiceBackend.post(`/cpv2/userGuide/increaseShowTimes`);
            localStorage.setItem('guideDoneStageNumber', String(Number(stageNumber) + 1));
        } else localStorage.setItem('guideDoneStageNumber', '1');
        this.$modal.hide(this.resChoosingUNIS);
        localStorage.setItem('guideDoneStage', 'Dashboard');
        this.$router.replace({
            name: 'Home',
        });
        util.showUserWalkthrough();
    }

    closeandreturntodashboard() {
        localStorage.setItem('guideDoneStageNumber', '3');
        localStorage.setItem('guideDone', 'true');
        this.$modal.hide(this.resChoosingUNIS);
        this.$router.replace({
            name: 'Home',
        });
    }

    doNotShowUserWalkthrough(isShowWalkthrough: any) {
        if (!isShowWalkthrough) {
            tmsServiceBackend.post(`/cpv2/userGuide/complete`).then(
                (res: any) => {
                    localStorage.setItem('guideDoneStageNumber', '3');
                    localStorage.setItem('guideDone', 'true');
                },
                (err: any) => {}
            );
        }
    }

    isgotItGettings: any = false;

    gotItfinished(name: any) {
        if (this.currentPageRows.length > 0) {
            this.isgotItGettings = true;
            localStorage.setItem('guideDoneStage', 'finished');
            this.onClickrow(this.currentPageRows[0]);
        } else {
            this.UserWalkNext();
        }
    }

    getPodFiles(podFiles: any) {
        if (!podFiles) return false;
        return true;
    }

    PodFiles(podFiles: any) {
        this.showPODfiles = true;
        this.editProductModal = 'filesmodalName';
        this.$modal.show(this.filesmodalName);
        this.PODfiles = podFiles.split(',');
        // window.open(url);
    }

    closeFilesmodalName() {
        this.$modal.hide(this.filesmodalName);
    }

    clickBatchImport() {
        this.batchImport({
            url: '/order/importOrder',
            title: 'Batch Import',
            order_id: '',
        })
            .then((ord: any) => {
                this.FilterTableSearch(1);
                this.succeed('Batch import success');
            })
            .catch((err: any) => {});
    }

    emitallshipments(shipmentsType: any) {
        console.log(shipmentsType);
        // this.$modal.hide(this.filesmodalName);
    }
    loadingExcel: boolean = false;
    ExportFileAciton() {
        let filter_strs: any = [];
        let status_type: any = '';
        let is_trip_order_created_from_lh: any = '';
        let FilterTables = this.FilterTables[0].filter
            ? this.FilterTables
            : this.cloneFilterTables.length > 0
            ? this.cloneFilterTables
            : [];
        forEach(FilterTables, Filter => {
            if (Filter.filter) {
                let keyVaule = `${Filter.filter}`;
                if (Filter.or == 'is') keyVaule = keyVaule + '=';
                if (Filter.or == 'is not') keyVaule = keyVaule + '!=';
                if (Filter.or == 'before') keyVaule = keyVaule + '<';
                if (Filter.or == 'after') keyVaule = keyVaule + '>';
                keyVaule = keyVaule + `'${Filter.value}'`;
                filter_strs.push(keyVaule);
            }
        });

        if (this.status_type && this.status_type != '0') {
            status_type = this.status_type;
            if (this.status_type == '5-1') {
                status_type = '5';
                is_trip_order_created_from_lh = '1';
            }
            if (this.status_type == '5') {
                status_type = '5';
                is_trip_order_created_from_lh = '0';
            }
        }

        this.loadingExcel = true;
        let _this = this;
        tmsServiceBlob
            .post(
                '/apinew/excel/order/export',
                qs.stringify({
                    billto: this.billto_id,
                    search_text: this.searchText,
                    status_type: status_type,
                    is_trip_order_created_from_lh: is_trip_order_created_from_lh,
                    filter_str: filter_strs,
                })
            )
            .then(function(response: any) {
                if (response.data.type == 'application/json') {
                    const data = new FileReader();
                    data.readAsText(response.data, 'utf-8');
                    data.onload = () => {
                        let dataResult: any = data.result;
                        let parseObj = JSON.parse(dataResult);
                        _this.err(parseObj.message);

                        _this.loadingExcel = false;
                        return;
                    };
                } else {
                    _this.cloneFilterTables = [];
                    _this.FilterTables = [
                        {
                            filter: '',
                            or: '',
                            value: '',
                        },
                    ];
                    let result = response.data;
                    _this.loadingExcel = false;
                    let date = new Date(+new Date() + 8 * 3600 * 1000)
                        .toJSON()
                        .substr(0, 19)
                        .replace('T', '');
                    let fileName = 'Shipments_export_' + date + '.xls';
                    let downloadUrl = URL.createObjectURL(result);
                    let a = document.createElement('a');
                    a.href = downloadUrl;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    analytics.trackFileDownload({
                        fileName: 'shipments_export',
                        fileType: 'xls',
                    });
                }
            })
            .catch(function(error) {
                console.log(error);
                _this.loadingExcel = false;
                _this.err(error);
            });
    }

    async chargeTrack(searchInfo: any) {
        this.trackingGuestOrderId = '';
        this.searchText = searchInfo;
        this.replaceUrl(searchInfo);

        await this.getCustomerData();
        this.FilterTableSearch(1);
    }

    replaceUrl(searchInfo: any) {
        let currentUrl: any = window.location.href;
        if (currentUrl.includes('searchText=') && searchInfo) {
            currentUrl = currentUrl.replace(/searchText=[^&]+/, `searchText=${searchInfo}`);
        } else {
            if (currentUrl.includes('?')) {
                if (searchInfo) currentUrl += `&searchText=${searchInfo}`;
            } else {
                if (searchInfo) currentUrl += `?searchText=${searchInfo}`;
            }
        }
        window.history.replaceState(null, '', currentUrl);
    }
    init() {
        this.timeArr = this.generateTimeArray();
    }
    generateTimeArray() {
        const timeArr = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 15) {
                const formattedHour = hour < 10 ? '0' + hour : '' + hour;
                const formattedMinute = minute < 10 ? '0' + minute : '' + minute;
                timeArr.push(`${formattedHour}:${formattedMinute}`);
            }
        }
        return timeArr;
    }
    changeTime(item: any) {
        let orderParams = {
            input_appointment_add_pid: item.pu_id,
            input_appointment_add_apt_num: item.shipper_pickup_no,
            input_appointment_add_apt_date: item.pickup_date,
            input_appointment_add_apt_time_from: item.pickup_ready + ':00',
            input_appointment_add_apt_time_to: item.pickup_close + ':00',
        };
        tmsServiceBackend.post(`/order/update_putime`, qs.stringify(orderParams)).then(
            (res: any) => {
                if (res.status == 200) {
                    this.$modal.show(this.ProductModal);
                }
                // this.callbackPlaceOrder(res);
            },
            (err: any) => {
                this.err(err.response.data.statusText);
            }
        );
    }

    /**
     * 格式化预约时间
     * @param timeFrom 起始时间（数字代表小时，或 HH:MM:SS 时间字符串）
     * @param timeTo 结束时间（数字代表小时，或 HH:MM:SS 时间字符串）
     * @returns 格式化后的时间字符串
     */
    formatAppointmentTime(timeFrom: any, timeTo: any): string {
        // 转换时间值为 HH:MM 格式
        const formatTimeValue = (value: any): string => {
            if (!value) return '';

            const strValue = String(value).trim();

            // 如果是 HH:MM:SS 格式，提取前 5 个字符 (HH:MM)
            if (strValue.includes(':')) {
                return strValue.substring(0, 5);
            }

            // 如果是数字（代表小时），转换为 HH:00 格式
            const hour = Number(value);
            if (isNaN(hour) || hour === 0) {
                return '';
            }
            return `${String(hour).padStart(2, '0')}:00`;
        };

        const fromStr = formatTimeValue(timeFrom);
        const toStr = formatTimeValue(timeTo);

        // 如果都没有值，不显示
        if (!fromStr && !toStr) {
            return '';
        }

        // 如果起始时间和结束时间相同，只显示一个
        if (fromStr === toStr) {
            return fromStr;
        }

        // 如果都有值，显示范围（使用 / 分隔）
        if (fromStr && toStr) {
            return `${fromStr} / ${toStr}`;
        }

        // 如果只有一个有值，显示那个
        return fromStr || toStr;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/shipment/index.ts